const HeaderResult = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}) => {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xl font-semibold capitalize">{title}</span>
      <span className="text-sm">{subtitle}</span>
    </div>
  );
};

export default HeaderResult;
